import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function DesireContractType() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [contractTypes, setContractTypes] = useState([]);

  useEffect(() => {
    CommonService.getContractType().then((data) => setContractTypes(data));
  }, []);
  
  return (
    <fieldset>
      <legend>{t("Desired Contract Type")}</legend>
      <select
        onChange={onChange}
        value={searchObject.desiredContractTypeId || ""}
        name="desiredContractTypeId"
        className="form-select"
      >
        <option value=""></option>
        {contractTypes.map((contract) => (
          <option value={contract.id} key={contract.id}>
            {t(contract.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
